// extracted by mini-css-extract-plugin
export var modal = "_e0-0";